<div
  class="menu-container"
  [class.expanded]="isMenuExpanded"
  *ngIf="viewMenu('edicaoEmpresa')"
  (click)="$event.stopPropagation()">
  <div
    class="menu-header"
    [ngClass]="{ 'expanded-center-icons': !isMenuExpanded }"
    (click)="expand(true)">
    <img
      [src]="brand.logoMenu"
      [ngClass]="{ 'display-none': !isMenuExpanded }"
      class="link"
      (click)="goTo('home')" />
    <img src="assets/menu.png" class="menu-image" />
    <div class="menu-mobile-icon">
      <menu-blue [size]="40" [isMobileMenuOpen]="isMobileMenuOpen" />
    </div>
  </div>
  <div
    class="menu-body"
    [ngClass]="{ 'menu-mobile-expanded': isMobileMenuOpen }"
    (click)="expand(false)">
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel
        #mapanel="matExpansionPanel"
        [hideToggle]="!isMenuExpanded"
        [disabled]="!isMenuExpanded"
        *ngIf="viewMenu('frotas')"
        (opened)="openAccordeon('frotas')"
        (closed)="closeAccordeon('frotas')"
        id="frotas"
        class="accordeon not-selected margin-bottom"
        [class.accordeon-collapsed]="!isMenuExpanded"
        [class.selected]="panelSelectedState['frotas']"
        [class.not-selected]="!panelSelectedState['frotas']">
        <mat-expansion-panel-header
          [ngClass]="{
            'padding-0': !isMenuExpanded
          }">
          <mat-panel-title
            class="accordeon-title"
            matTooltip="Frota"
            [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded
            }">
            <div
              class="menu-icon"
              [ngClass]="{
                'flex-center': !isMenuExpanded
              }">
              <img src="assets/icons/frota.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Cadastro de Frota
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p
          class="accordeon-content"
          (click)="goTo('listagem/cavalo')"
          *ngIf="viewMenu('listagemCavalo')">
          Cavalo
        </p>
        <p
          class="accordeon-content"
          (click)="goTo('listagem/carreta')"
          *ngIf="viewMenu('listagemCarreta')">
          Carreta
        </p>
        <p
          class="accordeon-content"
          (click)="goTo('listagem/motorista')"
          *ngIf="viewMenu('listagemMotorista')">
          Motorista
        </p>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel
        #mapanel="matExpansionPanel"
        [hideToggle]="!isMenuExpanded"
        [disabled]="!isMenuExpanded"
        (opened)="openAccordeon('agendamento')"
        (closed)="closeAccordeon('agendamento')"
        *ngIf="viewMenu('agendamento')"
        id="agendamento"
        class="accordeon not-selected margin-bottom"
        [class.accordeon-collapsed]="!isMenuExpanded"
        [class.selected]="panelSelectedState['agendamento']"
        [class.not-selected]="!panelSelectedState['agendamento']">
        <mat-expansion-panel-header
          [ngClass]="{
            'padding-0': !isMenuExpanded
          }">
          <mat-panel-title
            class="accordeon-title"
            matTooltip="Agendamento"
            [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded
            }">
            <div
              class="menu-icon"
              [ngClass]="{
                'flex-center': !isMenuExpanded
              }">
              <img src="assets/icons/agendamento.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Agendamento
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p
          class="accordeon-content"
          (click)="goTo('listagem/agendamento')"
          *ngIf="viewMenu('listagemAgendamento')">
          Agendamentos
        </p>
        <p
          class="accordeon-content"
          (click)="goTo('cadastro/agendamento')"
          *ngIf="viewMenu('cadastroAgendamento')">
          Novo Agendamento
        </p>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel
        #mapanel="matExpansionPanel"
        [hideToggle]="!isMenuExpanded"
        [disabled]="!isMenuExpanded"
        *ngIf="viewMenu('servicos')"
        (opened)="openAccordeon('servicos')"
        (closed)="closeAccordeon('servicos')"
        id="servicos"
        class="accordeon not-selected margin-bottom"
        [class.accordeon-collapsed]="!isMenuExpanded"
        [class.selected]="panelSelectedState['servicos']"
        [class.not-selected]="!panelSelectedState['servicos']">
        <mat-expansion-panel-header
          [ngClass]="{
            'padding-0': !isMenuExpanded
          }">
          <mat-panel-title
            class="accordeon-title"
            matTooltip="Serviços"
            [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded
            }">
            <div
              class="menu-icon"
              [ngClass]="{
                'flex-center': !isMenuExpanded
              }">
              <img src="assets/icons/servicos.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Serviços
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p
          class="accordeon-content"
          (click)="goTo('listagem/servicos')"
          *ngIf="viewMenu('listagemServicos')">
          Lista de Serviços
        </p>
        <p
          class="accordeon-content"
          (click)="goTo('cadastro/servicos')"
          *ngIf="viewMenu('cadastroServicos')">
          Novo Serviço
        </p>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel
        #mapanel="matExpansionPanel"
        [hideToggle]="!isMenuExpanded"
        [disabled]="!isMenuExpanded"
        *ngIf="viewMenu('laudosHigienizacao')"
        (opened)="openAccordeon('laudosHigienizacao')"
        (closed)="closeAccordeon('laudosHigienizacao')"
        id="laudosHigienizacao"
        class="accordeon not-selected margin-bottom"
        [class.accordeon-collapsed]="!isMenuExpanded"
        [class.selected]="panelSelectedState['laudosHigienizacao']"
        [class.not-selected]="!panelSelectedState['laudosHigienizacao']">
        <mat-expansion-panel-header
          [ngClass]="{
            'padding-0': !isMenuExpanded
          }">
          <mat-panel-title
            class="accordeon-title"
            matTooltip="Laudo de Higienização"
            [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded
            }">
            <div
              class="menu-icon"
              [ngClass]="{
                'flex-center': !isMenuExpanded
              }">
              <img src="assets/icons/laudos-higienizacao.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Laudo de Higienização
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p
          class="accordeon-content"
          (click)="goTo('listagem/laudos-higienizacao')"
          *ngIf="viewMenu('listagemLaudosHigienizacao')">
          Lista de Laudos
        </p>
        <p
          class="accordeon-content"
          (click)="goTo('cadastro/laudo-higienizacao')"
          *ngIf="viewMenu('cadastroLaudo')">
          Novo Laudo
        </p>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel
        #mapanel="matExpansionPanel"
        [hideToggle]="!isMenuExpanded"
        [disabled]="!isMenuExpanded"
        (opened)="openAccordeon('edicao-empresa')"
        (closed)="closeAccordeon('edicao-empresa')"
        *ngIf="viewMenu('edicaoEmpresa')"
        id="edicao-empresa"
        class="accordeon not-selected margin-bottom"
        [class.accordeon-collapsed]="!isMenuExpanded"
        [class.selected]="panelSelectedState['edicao-empresa']"
        [class.not-selected]="!panelSelectedState['edicao-empresa']">
        <mat-expansion-panel-header
          [ngClass]="{
            'padding-0': !isMenuExpanded
          }">
          <mat-panel-title
            class="accordeon-title"
            matTooltip="Acesso"
            [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded
            }">
            <div
              class="menu-icon"
              [ngClass]="{
                'flex-center': !isMenuExpanded
              }">
              <img src="assets/icons/gestao-acesso.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Acesso
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p
          class="accordeon-content"
          (click)="goTo('listagem/funcionario')"
          *ngIf="viewMenu('listagemFuncionario')">
          Funcionários
        </p>
        <p
          class="accordeon-content"
          (click)="goTo('edicao/cadastro')"
          *ngIf="viewMenu('edicaoEmpresa') && !isFuncionario()">
          Editar dados
        </p>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion class="sair">
      <div class="menu-items margin-bottom" id="sair">
        <div
          class="item-image"
          [ngClass]="{ 'item-image-100': !isMenuExpanded }">
          <img src="assets/log-out.svg" />
        </div>
        <div
          class="item-content"
          [ngClass]="{ 'display-none': !isMenuExpanded }">
          <p
            class="menu-content-text"
            *ngIf="isMenuExpanded"
            [@delayedDisplay]
            (click)="goTo('/')">
            Sair
          </p>
        </div>
      </div>
    </mat-accordion>
  </div>
</div>
